/**
 * Owner Customer CRM page wrapper — delegates to the shared
 * <CustomerCrmPage role="owner" />. Server derives brand_id from JWT.
 */
import CustomerCrmPage from '@/pages/CustomerCrmPage';
import { useAuthStore } from '@/lib/auth';

export default function OwnerCustomerCrmPage() {
  const brandId = useAuthStore((s) => s.user?.brand_id);
  return <CustomerCrmPage brandId={brandId} role="owner" />;
}
